<div
  class="overflow-y-auto max-h-[75vh] hide-scrollbar md:show-scrollbar"
  [loader]="mutationRequestPasswordReset()?.isLoading"
>
  <div
    class="relative w-[434px] max-w-full h-full px-8 pb-6 pt-16 rounded flex flex-col gap-4"
    [style.backgroundColor]="bgBase()"
  >
    <p class="text-center font-medium text-lg leading-none">
      {{ 'Zapomniałeś hasła?' | translate }}
    </p>

    <p class="text-sm leading-none text-center">
      {{
        'Podaj swój adres e-mail, a wyślemy Ci link do zresetowania hasła.'
          | translate
      }}
    </p>

    <form
      [formGroup]="restorePasswordFormVM"
      (ngSubmit)="onRestorePassword()"
      class="flex flex-col gap-4"
      role="form"
    >
      <fieldset class="flex flex-col gap-4">
        <legend class="sr-only">
          {{ 'Dane do resetu hasła' | translate }}
        </legend>

        <neopos-input-text
          inputId="input-email"
          formControlName="email"
          [label]="'Adres e-mail *' | translate"
          [placeholder]="'Wprowadź swój adres e-mail' | translate"
          labelMode="E-COMMERCE"
          [autoFocus]="true"
          [errorColor]="accent()"
          autocomplete="email"
        />
      </fieldset>

      <acc-button
        type="submit"
        [inputId]="'acc-button-restore-password-submit'"
        [attr.ariaLabel]="'Resetuj hasło' | translate"
      >
        {{ 'Resetuj hasło' | translate }}
      </acc-button>
    </form>

    <neopos-icon-button
      name="close"
      (click)="close()"
      (document:keydown.escape)="close()"
      className="text-[24px]"
      class="absolute top-4 right-4"
    />
  </div>
</div>
